import { adminApi } from "../../services/api";
import type { TranslationKeysResponse, TranslationLocalesResponse } from "./types";

/** Filtres exposés par la liste des clés. `all` n'en applique aucun. */
export type TranslationFilter = "all" | "missing" | "rejected" | "override" | "stale";

export const translationsApi = {
	listLocales: () => adminApi.get<TranslationLocalesResponse>("/admin/i18n/locales"),

	listKeys: (
		locale: string,
		params: { filter: TranslationFilter; q?: string; page: number; pageSize: number },
	) => {
		const query = new URLSearchParams({
			filter: params.filter,
			page: String(params.page),
			pageSize: String(params.pageSize),
		});
		if (params.q) query.set("q", params.q);
		return adminApi.get<TranslationKeysResponse>(
			`/admin/i18n/locales/${locale}/keys?${query.toString()}`,
		);
	},

	saveKey: (locale: string, key: string, value: string) =>
		adminApi.put<{ ok: true; version: number }>(
			`/admin/i18n/locales/${locale}/keys/${encodeURIComponent(key)}`,
			{ value },
		),

	resetKey: (locale: string, key: string) =>
		adminApi.delete<{ ok: true }>(
			`/admin/i18n/locales/${locale}/keys/${encodeURIComponent(key)}`,
		),

	retranslate: (locale: string, body: { keys?: string[]; force?: boolean } = {}) =>
		adminApi.post<{ locale: string; accepted: true }>(
			`/admin/i18n/locales/${locale}/retranslate`,
			body,
		),

	addLocale: (locale: string) =>
		adminApi.post<{ locale: string; created: boolean; willTranslate: boolean }>(
			"/admin/i18n/locales",
			{ locale },
		),

	deleteLocale: (locale: string) =>
		adminApi.delete<{ ok: true }>(`/admin/i18n/locales/${locale}`),
};
